// extracted by mini-css-extract-plugin
export default {"subscription":"SubscriptionCell_subscription__ZIL2+","subscriptionPlanName":"SubscriptionCell_subscriptionPlanName__kFurs","subscriptionId":"SubscriptionCell_subscriptionId__T+o6l"};